(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-create-share]";
  const MOBILE_MQ = "(max-width: 720px)";
  const DESIGN_PC = 2560;
  const DESIGN_M = 720;
  const FREEZE_PC = 1200;
  const FREEZE_M = 560;

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function spaceBetween() {
    if (isMobile()) {
      var mobileVw = Math.max(window.innerWidth, FREEZE_M);
      return Math.min((18 * mobileVw) / DESIGN_M, 18);
    }
    var pcVw = Math.max(window.innerWidth, FREEZE_PC);
    return Math.min((32 * pcVw) / DESIGN_PC, 32);
  }

  function offsetAfter(swiperEl) {
    var slide = swiperEl.querySelector(".create-share-slide");
    if (!slide) return 0;
    var swiperW = swiperEl.clientWidth;
    var cardW = slide.getBoundingClientRect().width;
    return Math.max(0, swiperW - cardW);
  }

  function destroySwiper(section) {
    if (section.__createShareSwiper) {
      section.__createShareSwiper.destroy(true, true);
      section.__createShareSwiper = null;
    }
  }

  function initSection(section) {
    if (!section || typeof Swiper === "undefined") return;

    var swiperEl = section.querySelector("[data-create-share-swiper]");
    if (!swiperEl) return;

    destroySwiper(section);

    var mobile = isMobile();
    section.__createShareMobile = mobile;

    var swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: spaceBetween(),
      slidesOffsetAfter: mobile ? offsetAfter(swiperEl) : 0,
      speed: 500,
      allowTouchMove: mobile,
      simulateTouch: mobile,
      grabCursor: mobile,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    });

    section.__createShareSwiper = swiper;
  }

  function updateAll() {
    var mobile = isMobile();
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (section) {
      if (section.__createShareMobile !== mobile) {
        initSection(section);
        return;
      }
      if (!section.__createShareSwiper || section.__createShareSwiper.destroyed) return;
      var el = section.querySelector("[data-create-share-swiper]");
      section.__createShareSwiper.params.spaceBetween = spaceBetween();
      section.__createShareSwiper.params.slidesOffsetAfter = mobile && el ? offsetAfter(el) : 0;
      section.__createShareSwiper.params.allowTouchMove = mobile;
      section.__createShareSwiper.params.simulateTouch = mobile;
      section.__createShareSwiper.allowTouchMove = mobile;
      section.__createShareSwiper.update();
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  var resizeFrame = 0;
  window.addEventListener("resize", function () {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(updateAll);
  });

  document.addEventListener("shopify:section:load", function (event) {
    var section =
      event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR);
    if (section) initSection(section);
  });
})();
